<template>
  <footer class="footer">
    <div :class="{ wrapper: true, centered: centered }">
      <p
        class="copyright"
        v-html="$t('layout.footer.copyright')"
      >
      </p>
      <a
        href='http://www.abg.info.pl/'
        class="link"
      >
        {{ $t('layout.footer.link') }}
      </a>
    </div>
  </footer>
</template>

<style scoped>
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 20px;
  }

  .wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    max-width: 1200px;
  }

  .centered {
    margin: 0 auto;
  }

  .copyright {
    margin-right: auto;
    font-size: 1.4rem;
    font-weight: 500;
    color: var(--secondary-text-color);
  }

  .link {
    position: relative;
    margin-left: 20px;
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--primary-color);
    text-decoration: none;
    transition: color 0.2s;
  }

  .link:hover,
  .link:focus,
  .link:active {
    color: var(--secondary-color);
  }
</style>

<script>
  export default {
    props: [ 'centered' ]
  }
</script>
